import React from 'react';

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '8px',
    padding: '12px',
    fontSize: '14px',
    color: '#6B7280',
  },
  dot: (color) => ({
    width: '8px',
    height: '8px',
    borderRadius: '50%',
    background: color,
    animation: 'pulse 1.5s ease-in-out infinite',
  }),
};

const statusConfig = {
  listening: { text: 'Lavan AI is listening...', color: '#16A34A' },
  thinking: { text: 'Lavan AI is thinking...', color: '#7C2BD0' },
  idle: null,
};

export default function StatusIndicator({ status = 'idle' }) {
  const config = statusConfig[status];
  if (!config) return null;

  return (
    <div style={styles.container}>
      <style>{`@keyframes pulse { 0%, 100% { opacity: 1; } 50% { opacity: 0.3; } }`}</style>
      <div style={styles.dot(config.color)} />
      <span>{config.text}</span>
    </div>
  );
}
